// import _ from 'lodash'
import { adminClient as apolloClient } from '@/store/apollo';

import UpdateStockGql from '@/extensions/shop/pointOfSale/store/graphql/mutations/UpdateStock.gql';

import { parseInt } from 'lodash';

export default {
    updateStock: variables => {
        variables = _.removeDeepByKey(variables, '__typename')
        return new Promise((resolve, reject) => {
            apolloClient.mutate({
                mutation: UpdateStockGql,
                variables
            })
                .then(({data}) => {
                    // apolloClient.clearStore()
                    resolve(data.EX_POS_UpdateStock)
                })
                .catch(err => reject(err))
        })
    }
};
